<template>
  <div class="main-content main-content_vertical">
    <div class="wrapper">
      <div class="h1 h1-mob-lg">{{$t('subscriptions.unsubscribe_header')}}</div>
      <p>{{ $t('subscriptions.are_you_sure_you_want_to_unsubscribe_from_level', { 'name': subscription.level.name, 'date': paidTillFormatted }) }}</p>
      <p v-if="downgradePlanned">{{ $t('subscriptions.the_transition_will_also_be_canceled', { 'name': nextLevel.name }) }}</p>
      <div class="btns">
        <router-link to="/subscriptions" class="black-link">{{$t('subscriptions.go_back')}}</router-link>
        <button class="btn-orange" @click="unsubscribe" :disabled="$store.getters.unsubscribeInProgress">
          {{ $t('subscriptions.unsubscribe') }}
        </button>
      </div>
      <div class="text-error" v-if="$store.getters.errorMessage">{{$store.getters.errorMessage}}</div>
    </div>
  </div>
</template>
<script>

import moment from "moment";
import SubscriptionStatus from "../store/models/SubscriptionStatus";

export default {
  name: "Unsubscribe",
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (!vm.$store.getters.authenticated) {
        next('/');
      } else if(vm.$store.getters.currentSubscription?.status !== SubscriptionStatus.Paid || (!vm.$store.getters.currentSubscription?.recurrent && vm.$store.getters.currentSubscription?.nextRecurrentPayment == null && vm.$store.getters.currentSubscription?.nextLevel == null) || vm.$store.getters.currentSubscription?.inPayment || vm.$store.getters.currentSubscription?.lastPayment == null) {
        next('/subscriptions');
      } else {
        next();
      }
    });
  },
  computed: {
    subscription() {
      return this.$store.getters.currentSubscription;
    },
    nextLevel() {
      return this.$store.getters.nextLevel;
    },
    downgradePlanned() {
      return this.$store.getters.downgradePlanned;
    },
    paidTillFormatted() {
      return this.subscription.paidTill ? moment(this.subscription.paidTill).format(this.$t('date_time_format')) : moment().format(this.$t('date_time_format'));
    },
  },
  methods: {
    unsubscribe() {
      this.$store.dispatch('unsubscribe');
    },
  },
};
</script>
<style lang="scss">
  .btns {
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
    .btn-orange {
      margin-bottom: 10px;
      margin-top: 10px;
    }
  }
  .text-error {
    color: red !important;
    margin-top: 20px;
  }
</style>
